import { Field, useField } from 'formik';
import { DatePicker, FormGroup } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommunicationDateField = _ref => {
  let {
    name
  } = _ref;
  const [, {
    error,
    touched
  }, {
    setValue
  }] = useField(name);
  return /*#__PURE__*/_jsx(FormGroup, {
    $width: "160u",
    error: touched && error,
    label: "Date",
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "CommunicationDateField",
    "data-sentry-source-file": "CommunicationDateField.tsx",
    children: /*#__PURE__*/_jsx(Field, {
      as: DatePicker,
      invalid: Boolean(touched && error),
      name: "date",
      onChange: setValue,
      "data-sentry-element": "Field",
      "data-sentry-source-file": "CommunicationDateField.tsx",
      "data-sentry-element": "Field"
    })
  });
};